import { lightBlue } from "../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export type StyleParams = {
  textDecorationStyle?: "solid" | "double" | "dotted" | "dashed" | "wavy"
}

export const useStyles = makeStyles<StyleParams>()(
  ({}, { textDecorationStyle = "solid" }) => ({
    customLink: {
      color: lightBlue[600],
      textDecorationColor: lightBlue[600],
      textDecorationStyle: textDecorationStyle,
      cursor: "pointer",

      "&:hover": {
        color: lightBlue[800],
        textDecorationColor: lightBlue[800],
        textDecorationStyle: textDecorationStyle
      }
    }
  })
)
